import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-34b33140"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "menu-left"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-upload-hd",
    title: "upload HD"
  }, null, -1);
});

var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  class: "postion-relative"
};
var _hoisted_5 = {
  key: 0,
  class: "switch_container"
};
var _hoisted_6 = {
  class: "label"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Dernier", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "separator"
  }, null, -1);
});

var _hoisted_9 = {
  class: "label"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Initial", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-select-floor",
    title: "select floor"
  }, null, -1);
});

var _hoisted_12 = [_hoisted_11];

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-select-wall",
    title: "select wall"
  }, null, -1);
});

var _hoisted_14 = [_hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$isCompare, _ctx$isCompare2;

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.openModalEspace && _ctx.openModalEspace.apply(_ctx, arguments);
    }),
    class: "rounded-top"
  }, _hoisted_3), _createElementVNode("li", _hoisted_4, [_createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleCompare({
        toggle: true
      });
    }),
    id: "btn-split-view",
    title: "Split view to compare products"
  }), _ctx.isCompare.active ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.handleCompare({
        mode: 'LAST'
      });
    }),
    type: "primary",
    size: "small",
    plain: !(((_ctx$isCompare = _ctx.isCompare) === null || _ctx$isCompare === void 0 ? void 0 : _ctx$isCompare.mode) == 'LAST')
  }, {
    default: _withCtx(function () {
      return [_hoisted_7];
    }),
    _: 1
  }, 8, ["plain"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.handleCompare({
        mode: 'INITIAL'
      });
    }),
    type: "primary",
    size: "small",
    plain: !(((_ctx$isCompare2 = _ctx.isCompare) === null || _ctx$isCompare2 === void 0 ? void 0 : _ctx$isCompare2.mode) == 'INITIAL')
  }, {
    default: _withCtx(function () {
      return [_hoisted_10];
    }),
    _: 1
  }, 8, ["plain"])])])) : _createCommentVNode("", true)]), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.openModalFloor && _ctx.openModalFloor.apply(_ctx, arguments);
    })
  }, _hoisted_12), _createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.openModalWall && _ctx.openModalWall.apply(_ctx, arguments);
    }),
    class: "rounded-bottom"
  }, _hoisted_14)])]);
}